import React from "react";
import "./Rightpart.css";
import "../../Pages/Cart.css";
import profile from "../assets/images/profile.png";
import deshboardimg from "../assets/images/deshboard-img.png";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import cartImg from "../../assets/images/cartImg.png";
import { useState } from "react";
import { Link } from "react-router-dom"; //Link

export default function WishlistRight() {

const [counter, setCounter] = useState(1);
  const inc = () => {
    setCounter(counter + 1);
  };

  const dec = () => {
    if (counter > 1) {
      setCounter(counter - 1);
    }
  };

  const [counter2, setCounter2] = useState(1);
  const inc2 = () => {
    setCounter2(counter2 + 1);
  };

  const dec2 = () => {
    if (counter2 > 1) {
      setCounter2(counter2 - 1);
    }
  };

   const [counter3, setCounter3] = useState(1);
  const inc3 = () => {
    setCounter3(counter3 + 1);
  };

  const dec3 = () => {
    if (counter3 > 1) {
      setCounter3(counter3 - 1);
    }
  };



  return (
    <div className="outer-div-right">
      <div className="dashbord-right-section">
        <div className="dashbord-header">
          <p className="title-dash">Wishlist</p>
          <div className="dropdown-sections d-flex align-items-center">
            <div className="dropdown">
              <button
                className="btn dropdown-toggle d-flex align-items-center gap-3"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <div className="profile-name">
                  <img src={profile} alt="" />
                  <div className="name-mail">
                    <h4>DEEPAK SHARMA</h4>
                    <p>Deepak@gmail.com</p>
                  </div>
                </div>
                <ExpandMoreIcon />
              </button>

              <ul className="dropdown-menu ">
                <li>
                  <a className="dropdown-item" href="#">
                    Profile
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Support
                  </a>
                </li>
                <li>
                  <a className="dropdown-item" href="#">
                    Logout
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="content-dashborad-outer">
          
           <div className="cart-page pb-0">
            <div className="container-fluid">
            <div className="row">
              <div className="col-lg-12 p-4">
                <h4 className="cart-title"> Items</h4>

                <div className="cart-item">
                  <img src={cartImg} alt="" className='img-fluid'/>

                  <div className="cart-details">
                    <div className="cart-name">
                      Nazakat Hand Woven Beige Cotton Cushion Cover
                    </div>
                    <div className="cart-meta">SKU: CU03970001_1.04x1.04</div>
                    <div className="cart-meta">Size: 46x46 cm</div>
                    <div className="cart-meta">Color: Cream</div>

                    <div>
                      <div className="qty-box">
                        <button onClick={dec3}>-</button>
                          <p className="number">{counter3}</p>
                          <button onClick={inc3}>+</button>
                      </div>
                       <Link to="/cart" className="wishlist">Add to Cart</Link>
                    </div>
                  </div>
 
                  <div className="cart-price">
                    ₹ 3,000
                    <button className="remove-btn">×</button>
                  </div>
                </div>

                <div className="cart-item">
                  <img src={cartImg} alt="" className='img-fluid'/>

                  <div className="cart-details">
                    <div className="cart-name">
                      Nazakat Hand Woven Beige Cotton Cushion Cover
                    </div>
                    <div className="cart-meta">SKU: CU03970001_1.04x1.04</div>
                    <div className="cart-meta">Size: 46x46 cm</div>
                    <div className="cart-meta">Color: Cream</div>

                    <div>
                      <div className="qty-box">
                          <button onClick={dec2}>-</button>
                          <p className="number">{counter2}</p>
                          <button onClick={inc2}>+</button>
                      </div>
                       <Link to="/cart" className="wishlist">Add to Cart</Link>
                    </div>
                  </div>

                  <div className="cart-price">
                    ₹ 3,000
                    <button className="remove-btn">×</button>
                  </div>
                </div>

                <div className="cart-item">
                  <img src={cartImg} alt="" className='img-fluid'/>

                  <div className="cart-details">
                    <div className="cart-name">
                      Nazakat Hand Woven Beige Cotton Cushion Cover
                    </div>
                    <div className="cart-meta">SKU: CU03970001_1.04x1.04</div>
                    <div className="cart-meta">Size: 46x46 cm</div>
                    <div className="cart-meta">Color: Cream</div>

                    <div>
                      <div className="qty-box">
                          <button onClick={dec}>-</button>
                          <p className="number">{counter}</p>
                          <button onClick={inc}>+</button>
                      </div>
                      <Link to="/cart" className="wishlist">Add to Cart</Link>
                    </div>
                  </div>

                  <div className="cart-price">
                    ₹ 3,000
                    <button className="remove-btn">×</button>
                  </div>
                </div>
                
              </div>

             
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
